/**
 * Placeholder body for a settings section whose real content hasn't been built
 * yet. The shell supplies the frame, heading, nav and document title; a section
 * swaps this out for its own component when its settings land — during the Clerk
 * rework for the ported tabs, or LG-412 for Sprint management.
 */
export function EmptySettingsSection() {
  return null
}
